import { useSyncExternalStore } from "react";
import { Error as AppError } from "@/util-components/root/types";
import { trackErrorDetailsViewed } from "@/lib/monitoring/error-interactions";

type ErrorDetailsStore = {
  error?: AppError;
  listeners: Set<() => void>;
};

const STORE_KEY = "__sportyPostErrorDetailsStore__";

const store = (() => {
  const globalScope = globalThis as typeof globalThis & {
    [STORE_KEY]?: ErrorDetailsStore;
  };

  if (!globalScope[STORE_KEY]) {
    globalScope[STORE_KEY] = {
      error: undefined,
      listeners: new Set(),
    };
  }

  return globalScope[STORE_KEY]!;
})();

const emitChange = () => {
  store.listeners.forEach((listener) => listener());
};

export const openErrorDetails = (error: AppError) => {
  if (store.error !== error) {
    trackErrorDetailsViewed(error);
  }

  store.error = error;
  emitChange();
};

export const closeErrorDetails = () => {
  store.error = undefined;
  emitChange();
};

export const getErrorDetails = () => store.error;

export const subscribeToErrorDetails = (listener: () => void) => {
  store.listeners.add(listener);

  return () => {
    store.listeners.delete(listener);
  };
};

export const useErrorDetails = () =>
  useSyncExternalStore(subscribeToErrorDetails, getErrorDetails, getErrorDetails);
